<template>
  <div>
    <div class="container">
      <div class="text-center">
        <div style="position: relative">
          <span class="font-backward session_name_profile font-weight-bold">
            Datos del cliente
          </span>
          <img class="img-session_name" src="@/assets/store/home/session_name.png" alt="">
        </div>
      </div>

      <form class="mt-5">
        <div class="text-center">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  * RFC
                </label>
                <input v-model="billing.rfc" name="rfc" v-validate="'required'" data-vv-as="RFC" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('rfc')" class="text-danger mt-2">
                  {{ errors.first("rfc") }}
                </span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  * No. Pedido
                </label>
                <input v-model="billing.order" name="order" v-validate="'required'" data-vv-as="Número de pedido" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('order')" class="text-danger mt-2">
                  {{ errors.first("order") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  * Uso factura
                </label> <br>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      color="primary"
                      block
                      v-bind="attrs"
                      v-on="on"
                      class="btn-dropdown-nv"
                    >
                      {{ billing.use ? billing.use : 'SELECCIONE' }}
                      <v-icon>mdi-menu-swap</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in uses_invoice"
                      :key="index"
                      @click="billing.use = item"
                    >
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <input type="hidden" v-model="billing.use" name="use" v-validate="'required'" data-vv-as="Uso de factura" class="input-nv" id="name">

                <span v-show="errors.has('use')" class="text-danger mt-2">
                  {{ errors.first("use") }}
                </span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  * Razón social
                </label>
                <input v-model="billing.reason" name="reason" v-validate="'required'" data-vv-as="Razón social" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('reason')" class="text-danger mt-2">
                  {{ errors.first("reason") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  Calle
                </label>
                <input v-model="billing.street" class="input-nv" id="name">
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  * Correo electronico
                </label>
                <input v-model="billing.email" name="email" v-validate="'required|email'" data-vv-as="Correo" type="email" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('email')" class="text-danger mt-2">
                  {{ errors.first("email") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  No. Interior
                </label>
                <input v-model="billing.inside" class="input-nv" id="name">
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  No. Exterior
                </label>
                <input v-model="billing.outside" class="input-nv" id="name">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  * Código postal
                </label>
                <input v-model="billing.zip" name="zip" v-validate="'required'" data-vv-as="Código postal" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('zip')" class="text-danger mt-2">
                  {{ errors.first("zip") }}
                </span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  Colonia
                </label>
                <input v-model="billing.colony" class="input-nv" id="name">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  Delegación / Municipio
                </label>
                <input v-model="billing.del_or_mcpio" class="input-nv" id="name">
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
              <div class="form-group col-sm-12">
                <label class="color-blue font-general-r h5 font-weight-bold" for="name">
                  Ciudad
                </label>
                <input v-model="billing.city" class="input-nv" id="name">
              </div>
            </div>
          </div>
        </div>

        <p class="color-blue font-general-r h4">
          Los campos marcados con (*) son obligatorios
        </p>
        <div class="text-center">
          <v-btn :loading="loading" @click="sendRequest" elevation="0" color="primary" class="nv-btn mt-5">
            FACTURAR
          </v-btn> <br>
          <v-btn @click="cancel()" text elevation="0" color="accent" class="mt-5 font-weight-bold">CANCELAR</v-btn>
        </div>


      </form>

    </div>

    <PopupMessage
      ref="popupMessage"
      message="Tu solicitud ha sido enviada, tendras tu factura a la brevedad posible"
    />

  </div>
</template>

<script>
import UserService from '@/services/user.service'

export default {
  data() {
    return {
      billing: {
        rfc: '',
        order: '',
        reason: '',
        use: '',
        email: '',
        street: '',
        inside: '',
        outside: '',
        zip: '',
        colony: '',
        del_or_mcpio: '',
        city: ''
      },

      uses_invoice: [
        'GASTOS EN GENERAL',
        'ADQUISICIÓN DE MERCANCIAS',
        'POR DEFINIR'
      ],

      loading: false
    }
  },
  methods: {
    async sendRequest() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          try {
            this.loading = true
            const { data:res } = await UserService.billingRequest(this.billing)
            if (res.success) {
              this.cancel()
              this.billing = {...this.$options.data().billing}
              this.$refs.popupMessage.openDialog()
            } else {
              this.$swal(res.error, '', 'warning')
            }
          } catch (error) {
            this.$swal('En estos momentos no estamos disponibles', '', 'warning')
          }
          this.loading = false
        }
      })
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
